import { render, staticRenderFns } from "./BankTransferModal.vue?vue&type=template&id=3926f9b0&scoped=true&"
import script from "./BankTransferModal.vue?vue&type=script&lang=ts&"
export * from "./BankTransferModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3926f9b0",
  null
  
)

export default component.exports